import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
var twMergeConfig = {
  // ↓ Optional prefix from TaiLwind config
  prefix: 'tw-'
};
var customTwMerge = /*#__PURE__*/extendTailwindMerge(twMergeConfig);
export function cn() {
  for (var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++) {
    inputs[_key] = arguments[_key];
  }
  return customTwMerge(clsx(inputs));
}
export function getFromNestedObject(obj, path) {
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var key = path[index];

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (!key) return '';
  var result = obj[key];

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (!result) return '';

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (typeof result === 'string') return result;
  return getFromNestedObject(Object(result), path, index + 1);
}